import { render, staticRenderFns } from "./ResultRow.vue?vue&type=template&id=b830b128&scoped=true&"
import script from "./ResultRow.vue?vue&type=script&lang=js&"
export * from "./ResultRow.vue?vue&type=script&lang=js&"
import style0 from "./ResultRow.vue?vue&type=style&index=0&id=b830b128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b830b128",
  null
  
)

export default component.exports